import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BriefForm from "./BriefForm";

export default function BriefFormWrapper() {
  const location = useLocation();
  const navigate = useNavigate();
  const [generatedBriefResponse, setGeneratedBriefResponse] = useState(null);
  const [toastList, setToastList] = useState([]);

  useEffect(() => {
    if (location.state?.briefData) {
      setGeneratedBriefResponse(location.state.briefData);
    } else {
      navigate("/brand/jobpostmain");
    }
  }, [location.state, navigate]);

  const handleBack = () => {
    if (location.state?.fromDescription) {
      navigate("/brand/jobpostdescription");
    } else if (location.state?.fromManual || generatedBriefResponse?.source === "manual") {
      navigate("/brand/jobpostmain");
    } else {
      navigate("/brand/jobpostdescription");
    }
  };

  const handleTabChange = (tab) => {
    if (tab === "main") {
      navigate("/brand/jobCampaigns");
    }
  };

  const refreshCampaignData = () => {
    navigate("/brand/jobCampaigns");
  };

  if (!generatedBriefResponse) {
    return <div>Loading...</div>;
  }

  return (
    <BriefForm
      generatedBriefResponse={generatedBriefResponse}
      onBack={handleBack}
      setTab={handleTabChange}
      setToastList={setToastList}
      toastList={toastList}
      isEditMode={location.state?.isEditMode || false}
      editCampaignData={location.state?.briefData}
      refreshCampaignData={refreshCampaignData}
    />
  );
}